import ReceivableInvoiceSerializer from './receivable-invoice';

export default class ReceivableCreditNoteSerializer extends ReceivableInvoiceSerializer {}
